module.exports = __webpack_public_path__ + "static/media/customer-2.262c2329.jpg";